import { useCallback } from 'react';
import { useThemeStore } from '../stores/themeStore';

/**
 * Custom hook for theme state and actions
 * Provides a clean API for components to interact with theme state
 */
export const useAppTheme = () => {
  const store = useThemeStore();
  
  // Stabilize function references to prevent infinite loops in useEffect
  const setMode = useCallback(
    (mode: 'light' | 'dark') => store.setMode(mode),
    [store.setMode]
  );
  
  const toggleMode = useCallback(
    () => store.toggleMode(),
    [store.toggleMode]
  );
  
  const setHideDrawerPlaceholder = useCallback(
    (hide: boolean) => store.setHideDrawerPlaceholder(hide),
    [store.setHideDrawerPlaceholder]
  );
  
  return {
    // State
    mode: store.mode,
    hideDrawerPlaceholder: store.hideDrawerPlaceholder,
    
    // Computed values
    isDarkMode: store.mode === 'dark',
    isLightMode: store.mode === 'light',
    
    // Actions (stabilized)
    setMode,
    toggleMode,
    setHideDrawerPlaceholder,
  };
};
